var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"align",attrs:{"id":"scrEnd"}},[_c('p',{staticClass:"ln3"},[_vm._v(_vm._s(_vm.scrMsg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }